import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ClFeature} from '@app/shared/changelog/version/version-detail/clfeature.model';

@Component({
  selector:        'app-version-detail',
  templateUrl:     './version-detail.component.html',
  styleUrls:       ['version-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true
})
export class VersionDetailComponent {
  @Input() clFeature: ClFeature;
  isClicked: boolean;


}
